import axiosClient from "utils/api/axios-client";

const collectionApi = {
  getAll: (params) => {
    const url = "/api/v1/collections";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/collections/${id}`;
    return axiosClient.get(url);
  },
  create: (collection) => {
    const url = `/api/v1/collections/`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.post(url, collection, config);
  },
  update: (id, collection) => {
    const url = `/api/v1/collections/${id}`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.put(url, collection, config);
  },
  delete: (id) => {
    const url = `/api/v1/collections/${id}`;
    return axiosClient.delete(url);
  },
};

export default collectionApi;
